import React, { useEffect } from 'react'
import { useField } from 'formik'
import { AnimatePresence } from 'framer-motion'

import { Loader } from '../../Icons'

import Forms from '../index'

import { ISelectGroupProps } from './interfaces'

import { Container, Field, Option, LoaderWrap, Arrow } from './styles'

const SelectGroup: React.FC<ISelectGroupProps> = (props) => {
  const [field, meta, helpers] = useField(props.name)

  useEffect(() => {
    return () => {
      helpers.setValue('')
    }
  }, [])

  return (
    <Container>
      {props.label && <Forms.Label>{props.label}</Forms.Label>}

      <Field>
        <Forms.Select
          {...props}
          {...field}
          disabled={props.loading || props.disabled}
          error={meta.touched && !!meta.error}
        >
          {props.loading ? (
            <Option value="">Carregando...</Option>
          ) : (
            props.options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))
          )}
        </Forms.Select>

        {props.loading && (
          <LoaderWrap>
            <Loader />
          </LoaderWrap>
        )}

        {!props.loading && (
          <Arrow.Box>
            <Arrow.Icon name="chevron-up" />
            <Arrow.Icon name="chevron-down" />
          </Arrow.Box>
        )}
      </Field>

      <AnimatePresence>
        {meta.touched && meta.error && (
          <Forms.Message kind="danger">{meta.error}</Forms.Message>
        )}
      </AnimatePresence>
    </Container>
  )
}

SelectGroup.defaultProps = {
  options: [],
}

export default SelectGroup
